// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const LinkExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#515156" />
				<g opacity={0.8}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M15.4999 12.729C15.8796 12.729 16.1874 13.0368 16.1874 13.4165C16.1874 13.7962 15.8796 14.104 15.4999 14.104H12.9999C11.0784 14.104 9.52075 15.6617 9.52075 17.5832C9.52075 18.5059 9.88731 19.3908 10.5398 20.0433C11.1922 20.6958 12.0772 21.0623 12.9999 21.0623H15.4999C15.8796 21.0623 16.1874 21.3701 16.1874 21.7498C16.1874 22.1295 15.8796 22.4373 15.4999 22.4373H12.9999C11.7125 22.4373 10.4778 21.9259 9.5675 21.0156C8.65717 20.1053 8.14575 18.8706 8.14575 17.5832C8.14575 14.9023 10.319 12.729 12.9999 12.729H15.4999ZM23 12.7291C24.2874 12.7291 25.5221 13.2405 26.4324 14.1509C27.3427 15.0612 27.8542 16.2959 27.8542 17.5833C27.8542 20.2642 25.6809 22.4375 23 22.4375H20.5C20.1203 22.4375 19.8125 22.1296 19.8125 21.75C19.8125 21.3703 20.1203 21.0625 20.5 21.0625H23C24.9215 21.0625 26.4792 19.5048 26.4792 17.5833C26.4792 16.6606 26.1126 15.7756 25.4601 15.1231C24.8077 14.4707 23.9227 14.1041 23 14.1041H20.5C20.1203 14.1041 19.8125 13.7963 19.8125 13.4166C19.8125 13.0369 20.1203 12.7291 20.5 12.7291H23ZM22.0209 17.5832C22.0209 17.2035 21.7131 16.8957 21.3334 16.8957H14.6668C14.2871 16.8957 13.9793 17.2035 13.9793 17.5832C13.9793 17.9629 14.2871 18.2707 14.6668 18.2707H21.3334C21.7131 18.2707 22.0209 17.9629 22.0209 17.5832Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
LinkExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default LinkExtension;
